import { useGoldConfig } from '@iheartjane/data-access/react-query';
import { shouldShowGold } from '@iheartjane/menu';
import { useMemo } from 'react';

import type { RootLoaderType } from '@jane/kiosk/data-access';
import { useTypedRouteLoaderData } from '@jane/kiosk/hooks/lib/useTypedRouteLoaderData';
import { useGetStore } from '@jane/shared/data-access';
import type { Store } from '@jane/shared/types';

export const useShouldKioskShowGold = (): boolean => {
  const { storeId, store: initialStore } =
    useTypedRouteLoaderData<RootLoaderType>('root');
  const { data: store } = useGetStore<Store>(storeId, {
    initialData: initialStore,
  });

  const { data: goldConfig, isPending: isLoadingGoldConfig } = useGoldConfig();

  const isAllowed =
    store?.kiosk_allow_auth && store?.kiosk_anonymous_checkout !== 'required';

  return useMemo(() => {
    if (!isAllowed) return false;
    if (isLoadingGoldConfig) return false;

    // check location and store ID and ignore the original janeGold flag
    if (goldConfig) {
      const validState = shouldShowGold({
        appMode: 'kiosk',
        goldConfig,
        state: store?.state,
        storeId: store?.id,
      });

      return validState;
    }

    return true;
  }, [goldConfig, isAllowed, isLoadingGoldConfig, store]);
};
